<template>
    <div class="group-picker">
	    <dropdown
            ref="picker"
            v-id="'group-picker'"
            :dismissable="false"
            @open="onDropdownOpen"
        >
		    <btn slot="toggle">
                {{ value ? value.reportName : '-- Choose a group --' }}
            </btn>
		    <list>
                <list-item v-focusable data-default>
                    <div style="position: relative;">
                        <input
                            v-id="'group-picker-filter'"
                            ref="filter"
                            v-control
                            v-model="local.filter"
                            placeholder="Filter…"
                            style="width: 100%;"
                            autocomplete="false"
                            @keydown.up.prevent
                            @keydown.down.prevent
                        />
                        <icon
                            v-if="local.filter"
                            v-clickable
                            src="close"
                            class="text-primary"
                            style="position: absolute; right: 4px; top: 6px;"
                            @click="clearFilter"
                        />
                    </div>
                </list-item>

			    <list-item
                    v-id="'group-option'"
                    v-for="group in options"
				    :key="group.locationGroupID"
                    v-focusable
				    :title="group.reportName"
                    :primary-icon="value && value.locationGroupID == group.locationGroupID ? 'check' : null"
				    clickable
                    inset
				    @click="setValue(group)"
			    />

                <list-item
                    v-if="!options.length"
                >
                    <div class="text-center">- No groups found -</div>
                </list-item>

                <template v-if="allowCreate">
			        <list-divider />
			        <list-item
                        v-focusable 
				        clickable 
				        title="New group…"
                        primary-icon="group_work"
				        @click="addGroup" 
			        />
                </template>
		    </list>
	    </dropdown>
    </div>
</template>


<script>
    import _ from 'lodash';
    import { LocalPropsMixin } from 'pdk/mixins';
    import { browser } from 'pdk/services';


    export default {
        name: 'group-picker',
        mixins: [LocalPropsMixin({
            filter: {
                type: String,
                default: null
            }
        })],		
        props: {
            value: {
                type: Object,
                default: null
            },
            allowCreate: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            mobile() {
                return browser.getBrowser().mobile;
            },
            locationGroups() {
                return this.$store.state.dashboard.locationGroups;
            },
            options() {
                let groups = this.locationGroups;

                if (this.local.filter) {
                    groups = _.filter(groups, (d) => d.reportName.toLowerCase().indexOf(this.local.filter.toLowerCase()) !== -1);
                }

                return _.orderBy(groups, [(d) => d.reportName.toLowerCase()], ['asc']);
            }
        },
        watch: {
            'local.filter'(value) {
                this.$emit('filter', value);
            }
        },
        methods: {
            close() {
                if (this.$refs.picker) this.$refs.picker.close();
                this.clearFilter();
            },
            clearFilter() {
                this.local.filter = null;

                if (this.$refs.filter) {
                    this.$refs.filter.focus();
                }
            },

            setValue(group) {
                this.close();

                this.$emit('input', group);
                this.$emit('change', group);
            },
            addGroup() {
                this.close();

                this.$emit('add');
            },

            onDropdownOpen() {
                if (!this.mobile) {
                    if (this.$refs.filter) {
                        this.$refs.filter.focus();
                    }
                }
            }
        }
	};
</script>
